import { render, staticRenderFns } from "./Mahnung.vue?vue&type=template&id=36e6b050"
import script from "./Mahnung.vue?vue&type=script&lang=js"
export * from "./Mahnung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports